import {Component, OnInit} from '@angular/core';
import {MenuComponent} from '@core/modules/layout/components/menu/menu.component';
import {RoleService} from '@core/modules/role/services/role.service';
import {Menu} from '@core/modules/layout/interfaces/menu.interface';
import {MenuIds} from '@core/modules/layout/enums/menu-ids.enum';
import {Roles} from '@core/modules/role/enums/roles.enum';

@Component({
  selector: 'app-menu-vertical',
  templateUrl: './menu-vertical.component.html',
})
export class MenuVerticalComponent extends MenuComponent implements OnInit {
  constructor(private roleService: RoleService) {
    super();
  }

  ngOnInit(): void {
    this.setDefaultSettingsExpandedForAdmin();
  }

  private setDefaultSettingsExpandedForAdmin(): void {
    const settingsIndex: number = this.menu.findIndex((item: Menu) => item.id === MenuIds.Settings);
    this.menu[settingsIndex].isExpanded = this.roleService.isRole(Roles.Admin);
  }
}
